export default "__VITE_ASSET__DOK8P0j___"